/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SwitchField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createNewContent } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function NewContentCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    title: "",
    type: "",
    category: "",
    director: "",
    actors: [],
    duration: "",
    releaseDate: "",
    description: "",
    language: "",
    filePath: "",
    rating: "",
    studio: "",
    country: "",
    year: "",
    posters: [],
    licensingInfo: "",
    fileSize: "",
    creators: [],
    author: "",
    genre: [],
    publisher: "",
    publicationYear: "",
    isSeries: false,
    isDrmProtected: false,
    isDrmEncodedSuccessfully: false,
    axinomDrmEncodingJobId: "",
    encodedFilePath: "",
    encodedFolderPath: "",
  };
  const [title, setTitle] = React.useState(initialValues.title);
  const [type, setType] = React.useState(initialValues.type);
  const [category, setCategory] = React.useState(initialValues.category);
  const [director, setDirector] = React.useState(initialValues.director);
  const [actors, setActors] = React.useState(initialValues.actors);
  const [duration, setDuration] = React.useState(initialValues.duration);
  const [releaseDate, setReleaseDate] = React.useState(
    initialValues.releaseDate
  );
  const [description, setDescription] = React.useState(
    initialValues.description
  );
  const [language, setLanguage] = React.useState(initialValues.language);
  const [filePath, setFilePath] = React.useState(initialValues.filePath);
  const [rating, setRating] = React.useState(initialValues.rating);
  const [studio, setStudio] = React.useState(initialValues.studio);
  const [country, setCountry] = React.useState(initialValues.country);
  const [year, setYear] = React.useState(initialValues.year);
  const [posters, setPosters] = React.useState(initialValues.posters);
  const [licensingInfo, setLicensingInfo] = React.useState(
    initialValues.licensingInfo
  );
  const [fileSize, setFileSize] = React.useState(initialValues.fileSize);
  const [creators, setCreators] = React.useState(initialValues.creators);
  const [author, setAuthor] = React.useState(initialValues.author);
  const [genre, setGenre] = React.useState(initialValues.genre);
  const [publisher, setPublisher] = React.useState(initialValues.publisher);
  const [publicationYear, setPublicationYear] = React.useState(
    initialValues.publicationYear
  );
  const [isSeries, setIsSeries] = React.useState(initialValues.isSeries);
  const [isDrmProtected, setIsDrmProtected] = React.useState(
    initialValues.isDrmProtected
  );
  const [isDrmEncodedSuccessfully, setIsDrmEncodedSuccessfully] =
    React.useState(initialValues.isDrmEncodedSuccessfully);
  const [axinomDrmEncodingJobId, setAxinomDrmEncodingJobId] = React.useState(
    initialValues.axinomDrmEncodingJobId
  );
  const [encodedFilePath, setEncodedFilePath] = React.useState(
    initialValues.encodedFilePath
  );
  const [encodedFolderPath, setEncodedFolderPath] = React.useState(
    initialValues.encodedFolderPath
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setTitle(initialValues.title);
    setType(initialValues.type);
    setCategory(initialValues.category);
    setDirector(initialValues.director);
    setActors(initialValues.actors);
    setCurrentActorsValue("");
    setDuration(initialValues.duration);
    setReleaseDate(initialValues.releaseDate);
    setDescription(initialValues.description);
    setLanguage(initialValues.language);
    setFilePath(initialValues.filePath);
    setRating(initialValues.rating);
    setStudio(initialValues.studio);
    setCountry(initialValues.country);
    setYear(initialValues.year);
    setPosters(initialValues.posters);
    setCurrentPostersValue("");
    setLicensingInfo(initialValues.licensingInfo);
    setFileSize(initialValues.fileSize);
    setCreators(initialValues.creators);
    setCurrentCreatorsValue("");
    setAuthor(initialValues.author);
    setGenre(initialValues.genre);
    setCurrentGenreValue("");
    setPublisher(initialValues.publisher);
    setPublicationYear(initialValues.publicationYear);
    setIsSeries(initialValues.isSeries);
    setIsDrmProtected(initialValues.isDrmProtected);
    setIsDrmEncodedSuccessfully(initialValues.isDrmEncodedSuccessfully);
    setAxinomDrmEncodingJobId(initialValues.axinomDrmEncodingJobId);
    setEncodedFilePath(initialValues.encodedFilePath);
    setEncodedFolderPath(initialValues.encodedFolderPath);
    setErrors({});
  };
  const [currentActorsValue, setCurrentActorsValue] = React.useState("");
  const actorsRef = React.createRef();
  const [currentPostersValue, setCurrentPostersValue] = React.useState("");
  const postersRef = React.createRef();
  const [currentCreatorsValue, setCurrentCreatorsValue] = React.useState("");
  const creatorsRef = React.createRef();
  const [currentGenreValue, setCurrentGenreValue] = React.useState("");
  const genreRef = React.createRef();
  const validations = {
    title: [{ type: "Required" }],
    type: [{ type: "Required" }],
    category: [{ type: "Required" }],
    director: [],
    actors: [],
    duration: [],
    releaseDate: [],
    description: [],
    language: [],
    filePath: [{ type: "Required" }],
    rating: [],
    studio: [],
    country: [],
    year: [],
    posters: [],
    licensingInfo: [],
    fileSize: [],
    creators: [],
    author: [],
    genre: [],
    publisher: [],
    publicationYear: [],
    isSeries: [],
    isDrmProtected: [],
    isDrmEncodedSuccessfully: [],
    axinomDrmEncodingJobId: [],
    encodedFilePath: [],
    encodedFolderPath: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          title,
          type,
          category,
          director,
          actors,
          duration,
          releaseDate,
          description,
          language,
          filePath,
          rating,
          studio,
          country,
          year,
          posters,
          licensingInfo,
          fileSize,
          creators,
          author,
          genre,
          publisher,
          publicationYear,
          isSeries,
          isDrmProtected,
          isDrmEncodedSuccessfully,
          axinomDrmEncodingJobId,
          encodedFilePath,
          encodedFolderPath,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createNewContent.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "NewContentCreateForm")}
      {...rest}
    >
      <TextField
        label="Title"
        isRequired={true}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title: value,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Type"
        isRequired={true}
        isReadOnly={false}
        value={type}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type: value,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.type ?? value;
          }
          if (errors.type?.hasError) {
            runValidationTasks("type", value);
          }
          setType(value);
        }}
        onBlur={() => runValidationTasks("type", type)}
        errorMessage={errors.type?.errorMessage}
        hasError={errors.type?.hasError}
        {...getOverrideProps(overrides, "type")}
      ></TextField>
      <TextField
        label="Category"
        isRequired={true}
        isReadOnly={false}
        value={category}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category: value,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.category ?? value;
          }
          if (errors.category?.hasError) {
            runValidationTasks("category", value);
          }
          setCategory(value);
        }}
        onBlur={() => runValidationTasks("category", category)}
        errorMessage={errors.category?.errorMessage}
        hasError={errors.category?.hasError}
        {...getOverrideProps(overrides, "category")}
      ></TextField>
      <TextField
        label="Director"
        isRequired={false}
        isReadOnly={false}
        value={director}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director: value,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.director ?? value;
          }
          if (errors.director?.hasError) {
            runValidationTasks("director", value);
          }
          setDirector(value);
        }}
        onBlur={() => runValidationTasks("director", director)}
        errorMessage={errors.director?.errorMessage}
        hasError={errors.director?.hasError}
        {...getOverrideProps(overrides, "director")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors: values,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            values = result?.actors ?? values;
          }
          setActors(values);
          setCurrentActorsValue("");
        }}
        currentFieldValue={currentActorsValue}
        label={"Actors"}
        items={actors}
        hasError={errors?.actors?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("actors", currentActorsValue)
        }
        errorMessage={errors?.actors?.errorMessage}
        setFieldValue={setCurrentActorsValue}
        inputFieldRef={actorsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Actors"
          isRequired={false}
          isReadOnly={false}
          value={currentActorsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.actors?.hasError) {
              runValidationTasks("actors", value);
            }
            setCurrentActorsValue(value);
          }}
          onBlur={() => runValidationTasks("actors", currentActorsValue)}
          errorMessage={errors.actors?.errorMessage}
          hasError={errors.actors?.hasError}
          ref={actorsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "actors")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Duration"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={duration}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration: value,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.duration ?? value;
          }
          if (errors.duration?.hasError) {
            runValidationTasks("duration", value);
          }
          setDuration(value);
        }}
        onBlur={() => runValidationTasks("duration", duration)}
        errorMessage={errors.duration?.errorMessage}
        hasError={errors.duration?.hasError}
        {...getOverrideProps(overrides, "duration")}
      ></TextField>
      <TextField
        label="Release date"
        isRequired={false}
        isReadOnly={false}
        value={releaseDate}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate: value,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.releaseDate ?? value;
          }
          if (errors.releaseDate?.hasError) {
            runValidationTasks("releaseDate", value);
          }
          setReleaseDate(value);
        }}
        onBlur={() => runValidationTasks("releaseDate", releaseDate)}
        errorMessage={errors.releaseDate?.errorMessage}
        hasError={errors.releaseDate?.hasError}
        {...getOverrideProps(overrides, "releaseDate")}
      ></TextField>
      <TextField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        value={description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description: value,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.description ?? value;
          }
          if (errors.description?.hasError) {
            runValidationTasks("description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("description", description)}
        errorMessage={errors.description?.errorMessage}
        hasError={errors.description?.hasError}
        {...getOverrideProps(overrides, "description")}
      ></TextField>
      <TextField
        label="Language"
        isRequired={false}
        isReadOnly={false}
        value={language}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language: value,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.language ?? value;
          }
          if (errors.language?.hasError) {
            runValidationTasks("language", value);
          }
          setLanguage(value);
        }}
        onBlur={() => runValidationTasks("language", language)}
        errorMessage={errors.language?.errorMessage}
        hasError={errors.language?.hasError}
        {...getOverrideProps(overrides, "language")}
      ></TextField>
      <TextField
        label="File path"
        isRequired={true}
        isReadOnly={false}
        value={filePath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath: value,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.filePath ?? value;
          }
          if (errors.filePath?.hasError) {
            runValidationTasks("filePath", value);
          }
          setFilePath(value);
        }}
        onBlur={() => runValidationTasks("filePath", filePath)}
        errorMessage={errors.filePath?.errorMessage}
        hasError={errors.filePath?.hasError}
        {...getOverrideProps(overrides, "filePath")}
      ></TextField>
      <TextField
        label="Rating"
        isRequired={false}
        isReadOnly={false}
        value={rating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating: value,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.rating ?? value;
          }
          if (errors.rating?.hasError) {
            runValidationTasks("rating", value);
          }
          setRating(value);
        }}
        onBlur={() => runValidationTasks("rating", rating)}
        errorMessage={errors.rating?.errorMessage}
        hasError={errors.rating?.hasError}
        {...getOverrideProps(overrides, "rating")}
      ></TextField>
      <TextField
        label="Studio"
        isRequired={false}
        isReadOnly={false}
        value={studio}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio: value,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.studio ?? value;
          }
          if (errors.studio?.hasError) {
            runValidationTasks("studio", value);
          }
          setStudio(value);
        }}
        onBlur={() => runValidationTasks("studio", studio)}
        errorMessage={errors.studio?.errorMessage}
        hasError={errors.studio?.hasError}
        {...getOverrideProps(overrides, "studio")}
      ></TextField>
      <TextField
        label="Country"
        isRequired={false}
        isReadOnly={false}
        value={country}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country: value,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.country ?? value;
          }
          if (errors.country?.hasError) {
            runValidationTasks("country", value);
          }
          setCountry(value);
        }}
        onBlur={() => runValidationTasks("country", country)}
        errorMessage={errors.country?.errorMessage}
        hasError={errors.country?.hasError}
        {...getOverrideProps(overrides, "country")}
      ></TextField>
      <TextField
        label="Year"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={year}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year: value,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.year ?? value;
          }
          if (errors.year?.hasError) {
            runValidationTasks("year", value);
          }
          setYear(value);
        }}
        onBlur={() => runValidationTasks("year", year)}
        errorMessage={errors.year?.errorMessage}
        hasError={errors.year?.hasError}
        {...getOverrideProps(overrides, "year")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters: values,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            values = result?.posters ?? values;
          }
          setPosters(values);
          setCurrentPostersValue("");
        }}
        currentFieldValue={currentPostersValue}
        label={"Posters"}
        items={posters}
        hasError={errors?.posters?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("posters", currentPostersValue)
        }
        errorMessage={errors?.posters?.errorMessage}
        setFieldValue={setCurrentPostersValue}
        inputFieldRef={postersRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Posters"
          isRequired={false}
          isReadOnly={false}
          value={currentPostersValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.posters?.hasError) {
              runValidationTasks("posters", value);
            }
            setCurrentPostersValue(value);
          }}
          onBlur={() => runValidationTasks("posters", currentPostersValue)}
          errorMessage={errors.posters?.errorMessage}
          hasError={errors.posters?.hasError}
          ref={postersRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "posters")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Licensing info"
        isRequired={false}
        isReadOnly={false}
        value={licensingInfo}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo: value,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.licensingInfo ?? value;
          }
          if (errors.licensingInfo?.hasError) {
            runValidationTasks("licensingInfo", value);
          }
          setLicensingInfo(value);
        }}
        onBlur={() => runValidationTasks("licensingInfo", licensingInfo)}
        errorMessage={errors.licensingInfo?.errorMessage}
        hasError={errors.licensingInfo?.hasError}
        {...getOverrideProps(overrides, "licensingInfo")}
      ></TextField>
      <TextField
        label="File size"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={fileSize}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize: value,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.fileSize ?? value;
          }
          if (errors.fileSize?.hasError) {
            runValidationTasks("fileSize", value);
          }
          setFileSize(value);
        }}
        onBlur={() => runValidationTasks("fileSize", fileSize)}
        errorMessage={errors.fileSize?.errorMessage}
        hasError={errors.fileSize?.hasError}
        {...getOverrideProps(overrides, "fileSize")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators: values,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            values = result?.creators ?? values;
          }
          setCreators(values);
          setCurrentCreatorsValue("");
        }}
        currentFieldValue={currentCreatorsValue}
        label={"Creators"}
        items={creators}
        hasError={errors?.creators?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("creators", currentCreatorsValue)
        }
        errorMessage={errors?.creators?.errorMessage}
        setFieldValue={setCurrentCreatorsValue}
        inputFieldRef={creatorsRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Creators"
          isRequired={false}
          isReadOnly={false}
          value={currentCreatorsValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.creators?.hasError) {
              runValidationTasks("creators", value);
            }
            setCurrentCreatorsValue(value);
          }}
          onBlur={() => runValidationTasks("creators", currentCreatorsValue)}
          errorMessage={errors.creators?.errorMessage}
          hasError={errors.creators?.hasError}
          ref={creatorsRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "creators")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Author"
        isRequired={false}
        isReadOnly={false}
        value={author}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author: value,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.author ?? value;
          }
          if (errors.author?.hasError) {
            runValidationTasks("author", value);
          }
          setAuthor(value);
        }}
        onBlur={() => runValidationTasks("author", author)}
        errorMessage={errors.author?.errorMessage}
        hasError={errors.author?.hasError}
        {...getOverrideProps(overrides, "author")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre: values,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            values = result?.genre ?? values;
          }
          setGenre(values);
          setCurrentGenreValue("");
        }}
        currentFieldValue={currentGenreValue}
        label={"Genre"}
        items={genre}
        hasError={errors?.genre?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("genre", currentGenreValue)
        }
        errorMessage={errors?.genre?.errorMessage}
        setFieldValue={setCurrentGenreValue}
        inputFieldRef={genreRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Genre"
          isRequired={false}
          isReadOnly={false}
          value={currentGenreValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.genre?.hasError) {
              runValidationTasks("genre", value);
            }
            setCurrentGenreValue(value);
          }}
          onBlur={() => runValidationTasks("genre", currentGenreValue)}
          errorMessage={errors.genre?.errorMessage}
          hasError={errors.genre?.hasError}
          ref={genreRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "genre")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Publisher"
        isRequired={false}
        isReadOnly={false}
        value={publisher}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher: value,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.publisher ?? value;
          }
          if (errors.publisher?.hasError) {
            runValidationTasks("publisher", value);
          }
          setPublisher(value);
        }}
        onBlur={() => runValidationTasks("publisher", publisher)}
        errorMessage={errors.publisher?.errorMessage}
        hasError={errors.publisher?.hasError}
        {...getOverrideProps(overrides, "publisher")}
      ></TextField>
      <TextField
        label="Publication year"
        isRequired={false}
        isReadOnly={false}
        type="number"
        step="any"
        value={publicationYear}
        onChange={(e) => {
          let value = isNaN(parseInt(e.target.value))
            ? e.target.value
            : parseInt(e.target.value);
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear: value,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.publicationYear ?? value;
          }
          if (errors.publicationYear?.hasError) {
            runValidationTasks("publicationYear", value);
          }
          setPublicationYear(value);
        }}
        onBlur={() => runValidationTasks("publicationYear", publicationYear)}
        errorMessage={errors.publicationYear?.errorMessage}
        hasError={errors.publicationYear?.hasError}
        {...getOverrideProps(overrides, "publicationYear")}
      ></TextField>
      <SwitchField
        label="Is series"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isSeries}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries: value,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.isSeries ?? value;
          }
          if (errors.isSeries?.hasError) {
            runValidationTasks("isSeries", value);
          }
          setIsSeries(value);
        }}
        onBlur={() => runValidationTasks("isSeries", isSeries)}
        errorMessage={errors.isSeries?.errorMessage}
        hasError={errors.isSeries?.hasError}
        {...getOverrideProps(overrides, "isSeries")}
      ></SwitchField>
      <SwitchField
        label="Is drm protected"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isDrmProtected}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected: value,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.isDrmProtected ?? value;
          }
          if (errors.isDrmProtected?.hasError) {
            runValidationTasks("isDrmProtected", value);
          }
          setIsDrmProtected(value);
        }}
        onBlur={() => runValidationTasks("isDrmProtected", isDrmProtected)}
        errorMessage={errors.isDrmProtected?.errorMessage}
        hasError={errors.isDrmProtected?.hasError}
        {...getOverrideProps(overrides, "isDrmProtected")}
      ></SwitchField>
      <SwitchField
        label="Is drm encoded successfully"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isDrmEncodedSuccessfully}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully: value,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.isDrmEncodedSuccessfully ?? value;
          }
          if (errors.isDrmEncodedSuccessfully?.hasError) {
            runValidationTasks("isDrmEncodedSuccessfully", value);
          }
          setIsDrmEncodedSuccessfully(value);
        }}
        onBlur={() =>
          runValidationTasks(
            "isDrmEncodedSuccessfully",
            isDrmEncodedSuccessfully
          )
        }
        errorMessage={errors.isDrmEncodedSuccessfully?.errorMessage}
        hasError={errors.isDrmEncodedSuccessfully?.hasError}
        {...getOverrideProps(overrides, "isDrmEncodedSuccessfully")}
      ></SwitchField>
      <TextField
        label="Axinom drm encoding job id"
        isRequired={false}
        isReadOnly={false}
        value={axinomDrmEncodingJobId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId: value,
              encodedFilePath,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.axinomDrmEncodingJobId ?? value;
          }
          if (errors.axinomDrmEncodingJobId?.hasError) {
            runValidationTasks("axinomDrmEncodingJobId", value);
          }
          setAxinomDrmEncodingJobId(value);
        }}
        onBlur={() =>
          runValidationTasks("axinomDrmEncodingJobId", axinomDrmEncodingJobId)
        }
        errorMessage={errors.axinomDrmEncodingJobId?.errorMessage}
        hasError={errors.axinomDrmEncodingJobId?.hasError}
        {...getOverrideProps(overrides, "axinomDrmEncodingJobId")}
      ></TextField>
      <TextField
        label="Encoded file path"
        isRequired={false}
        isReadOnly={false}
        value={encodedFilePath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath: value,
              encodedFolderPath,
            };
            const result = onChange(modelFields);
            value = result?.encodedFilePath ?? value;
          }
          if (errors.encodedFilePath?.hasError) {
            runValidationTasks("encodedFilePath", value);
          }
          setEncodedFilePath(value);
        }}
        onBlur={() => runValidationTasks("encodedFilePath", encodedFilePath)}
        errorMessage={errors.encodedFilePath?.errorMessage}
        hasError={errors.encodedFilePath?.hasError}
        {...getOverrideProps(overrides, "encodedFilePath")}
      ></TextField>
      <TextField
        label="Encoded folder path"
        isRequired={false}
        isReadOnly={false}
        value={encodedFolderPath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              title,
              type,
              category,
              director,
              actors,
              duration,
              releaseDate,
              description,
              language,
              filePath,
              rating,
              studio,
              country,
              year,
              posters,
              licensingInfo,
              fileSize,
              creators,
              author,
              genre,
              publisher,
              publicationYear,
              isSeries,
              isDrmProtected,
              isDrmEncodedSuccessfully,
              axinomDrmEncodingJobId,
              encodedFilePath,
              encodedFolderPath: value,
            };
            const result = onChange(modelFields);
            value = result?.encodedFolderPath ?? value;
          }
          if (errors.encodedFolderPath?.hasError) {
            runValidationTasks("encodedFolderPath", value);
          }
          setEncodedFolderPath(value);
        }}
        onBlur={() =>
          runValidationTasks("encodedFolderPath", encodedFolderPath)
        }
        errorMessage={errors.encodedFolderPath?.errorMessage}
        hasError={errors.encodedFolderPath?.hasError}
        {...getOverrideProps(overrides, "encodedFolderPath")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
